import axios from "axios";
import { toast } from "react-toastify";
import { REPORT_AI_BASE_URL } from "../constants/api";
import ReportingUtils from "../utilities/ReportingUtils";

const reportAIAxios = axios.create({
  baseURL: REPORT_AI_BASE_URL,
  headers: {
    "Content-type": "application/json",
  },
});

const requestHandler = (request) => {
  return request;
};

const responseHandler = (response) => {
  return response;
};

const errorHandler = (error) => {
  const _ = ReportingUtils.decodeErrorMessage(error?.response?.status, error?.response?.data?.detail);
  toast.error(
    <div>
      <h6>{_.header}</h6>
      <div>{_.message}</div>
    </div>, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: false
  });
  return Promise.reject(error);
};

reportAIAxios.interceptors.request.use(
  function (config) {
    return requestHandler(config);
  },
  function (error) {    
    return errorHandler(error);
  }
);

reportAIAxios.interceptors.response.use(
  function (response) {    
    return responseHandler(response);
  },
  function (error) {    
    if (error.config.url === "/ai/classification/v1") {
      return error.response;
    } else {
      return errorHandler(error);
    }
  }
);

export default reportAIAxios;
